


























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditKepatuhanPpiService from "@/services/AuditKepatuhanPpiService";
import { SEKSI_ORDER } from "@/constants/seksiAuditKepatuhanPpi";

@Component
export default class AuditKepatuhanPpiDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  seksiMeta: Record<string, any> = {};

  signDialog = false;
  signStage: "auditor" | "ketua_ppi" | "kaunit" | "direktur" | null = null;
  signPassword = "";
  signing = false;

  temuanDialog = false;
  temuanForm: any = {};
  savingTemuan = false;

  kesimpulanModel = "";

  statusTemuanOptions = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  temuanHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Seksi", value: "seksi", width: 140 },
    { text: "Temuan", value: "uraian" },
    { text: "RTL", value: "rencana_tindak_lanjut" },
    { text: "PIC", value: "pic_nama" },
    { text: "Target", value: "target_waktu" },
    { text: "Status", value: "status_chip" },
    { text: "", value: "actions", sortable: false, width: 80 }
  ];

  signStages = [
    {
      key: "auditor",
      label: "Auditor / Tim PPI",
      sub: "Dibuat Oleh",
      timestampField: "signed_auditor_at",
      waitFor: "—",
      getName: (s: any) => s.auditor_nama || (s.auditor && s.auditor.identitas && s.auditor.identitas.nama),
      canSign: (s: any) => !s.signed_auditor_at
    },
    {
      key: "ketua_ppi",
      label: "Ketua Komite PPI",
      sub: "Diperiksa Oleh",
      timestampField: "signed_ketua_ppi_at",
      waitFor: "Auditor",
      getName: (s: any) => s.signed_ketua_ppi && s.signed_ketua_ppi.identitas && s.signed_ketua_ppi.identitas.nama,
      canSign: (s: any) => !!s.signed_auditor_at && !s.signed_ketua_ppi_at
    },
    {
      key: "kaunit",
      label: "Ka. Unit / Kepala Ruangan",
      sub: "Disetujui Oleh",
      timestampField: "signed_kaunit_at",
      waitFor: "Ketua PPI",
      getName: (s: any) => s.signed_kaunit && s.signed_kaunit.identitas && s.signed_kaunit.identitas.nama,
      canSign: (s: any) => !!s.signed_ketua_ppi_at && !s.signed_kaunit_at
    },
    {
      key: "direktur",
      label: "Direktur / Pimpinan",
      sub: "Mengetahui",
      timestampField: "signed_direktur_at",
      waitFor: "Ka. Unit",
      getName: (s: any) => s.signed_direktur && s.signed_direktur.identitas && s.signed_direktur.identitas.nama,
      canSign: (s: any) => !!s.signed_kaunit_at && !s.signed_direktur_at
    }
  ];

  get signStageLabel() {
    const s = this.signStages.find(x => x.key === this.signStage);
    return s ? `${s.label} — ${s.sub}` : "";
  }

  get sections() {
    const items = this.session ? this.session.items || [] : [];
    return SEKSI_ORDER.filter(k => this.seksiMeta[k]).map(key => {
      const meta = this.seksiMeta[key];
      const rows = items
        .filter((r: any) => r.seksi === key)
        .sort((a: any, b: any) => (a.item_urutan || 0) - (b.item_urutan || 0));
      return { key, meta, rows };
    }).filter(s => s.rows.length > 0);
  }

  get seksiSelectOptions() {
    return SEKSI_ORDER.filter(k => this.seksiMeta[k]).map(k => ({
      text: `${this.seksiMeta[k].huruf}. ${this.seksiMeta[k].label}`,
      value: k
    }));
  }

  countHasil(rows: any[], v: string): number {
    return rows.filter(r => r.hasil === v).length;
  }

  subRate(section: any): number | null {
    const ya = this.countHasil(section.rows, "ya");
    const tidak = this.countHasil(section.rows, "tidak");
    const denom = ya + tidak;
    return denom > 0 ? Math.round((ya / denom) * 10000) / 100 : null;
  }

  subColor(section: any): string {
    const r = this.subRate(section);
    if (r === null) return "grey";
    if (r >= 85) return "success";
    if (r >= 76) return "warning";
    return "error";
  }

  async mounted() {
    await this.loadCatalog();
    await this.loadSession();
  }

  async loadCatalog() {
    const res = await AuditKepatuhanPpiService.getCatalog();
    this.seksiMeta = res.data.data.seksi || {};
  }

  async loadSession() {
    const res = await AuditKepatuhanPpiService.find(this.sessionId);
    this.session = res.data.data;
    this.kesimpulanModel = this.session.kesimpulan_umum || "";
  }

  async saveKesimpulan() {
    if (this.session.is_locked) return;
    if ((this.kesimpulanModel || "") === (this.session.kesimpulan_umum || "")) return;
    await AuditKepatuhanPpiService.update(this.session.id, {
      unit_id: this.session.unit_id,
      tanggal_audit: this.session.tanggal_audit,
      metode_audit: this.session.metode_audit,
      periode_bulan: this.session.periode_bulan,
      periode_tahun: this.session.periode_tahun,
      kesimpulan_umum: this.kesimpulanModel
    });
    this.session.kesimpulan_umum = this.kesimpulanModel;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }

  bulanName(b: number): string {
    const names = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return names[b] || "";
  }

  printPdf() {
    AuditKepatuhanPpiService.printPdf(this.session.id);
  }

  openSignDialog(stage: "auditor" | "ketua_ppi" | "kaunit" | "direktur") {
    this.signStage = stage;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signStage) return;
    this.signing = true;
    try {
      const handlers: any = {
        auditor: AuditKepatuhanPpiService.submitAuditor,
        ketua_ppi: AuditKepatuhanPpiService.verifyKetuaPpi,
        kaunit: AuditKepatuhanPpiService.approveKaunit,
        direktur: AuditKepatuhanPpiService.approveDirektur
      };
      await handlers[this.signStage](this.session.id, { password: this.signPassword });
      this.signDialog = false;
      await this.loadSession();
    } finally {
      this.signing = false;
    }
  }

  openTemuan(t?: any) {
    this.temuanForm = t
      ? { ...t }
      : {
          uraian: "",
          seksi: null,
          akar_masalah: "",
          rencana_tindak_lanjut: "",
          pic_nama: "",
          target_waktu: "",
          status: "open"
        };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    if (!this.temuanForm.uraian || !this.temuanForm.rencana_tindak_lanjut) return;
    this.savingTemuan = true;
    try {
      if (this.temuanForm.id) {
        await AuditKepatuhanPpiService.updateTemuan(this.session.id, this.temuanForm.id, this.temuanForm);
      } else {
        await AuditKepatuhanPpiService.storeTemuan(this.session.id, this.temuanForm);
      }
      this.temuanDialog = false;
      await this.loadSession();
    } finally {
      this.savingTemuan = false;
    }
  }

  async deleteTemuan(t: any) {
    if (!confirm(`Hapus temuan #${t.urutan}?`)) return;
    await AuditKepatuhanPpiService.destroyTemuan(this.session.id, t.id);
    await this.loadSession();
  }
}
